<template>
  <content-loader
    view-box="0 0 420 165"
    :speed="2"
    primary-color="#f3f3f3"
    secondary-color="#ecebeb"
    height="186"
  >
    <circle cx="200" cy="44" r="32" /> 
    <rect x="7" y="112" rx="0" ry="0" width="188" height="16" /> 
    <rect x="207" y="112" rx="0" ry="0" width="188" height="16" /> 
    <circle cx="224" cy="61" r="7" /> 
    <rect x="326" y="153" rx="0" ry="0" width="68" height="18" /> 
    <rect x="8" y="105" rx="0" ry="0" width="48" height="5" /> 
    <rect x="207" y="104" rx="0" ry="0" width="48" height="5" />
  </content-loader>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
    name: "ProfileLoader",
    components: { ContentLoader }
};
</script>